import React from 'react';
import EmptyInteractable from './EmptyInteractable';

const Slots = ({ onClick, ...props }) => <EmptyInteractable onClick={() => onClick(props)} />;

export default Slots;
